export const getSmsOptions = (t: Function) => [
  { value: '1d', label: t('Today') },
  { value: '7d', label: t('Last 7 days') },
  { value: 'MTD', label: t('Month to Date') },
  { value: '30d', label: t('Last 30 days') },
  { value: 'YTD', label: t('Year to Date') },
];

export const getSmsOptionsMapping = (t: Function) => ({
  '1d': t('Today'),
  '7d': t('Last 7 days'),
  MTD: t('Month to Date'),
  '30d': t('Last 30 days'),
  YTD: t('Year to Date'),
});
